import React from "react";
import styles from "./styles.module.css";

const ButtonLoader = () => {
  return <div className={styles.loader}></div>;
};

export default ButtonLoader;
